import React from "react";
import { CheckCircleIcon } from "@heroicons/react/20/solid";

const ACCENT = "#1b4d2e";

/**
 * Card shell used to wrap a titled section with optional icon and "completo"/count badge.
 * Used by VenuePage and CatalogosManager so both share the same look.
 *
 * Props:
 *  - id: anchor id (for scrollspy navigation)
 *  - title: header text
 *  - icon: heroicon element (rendered ~16px)
 *  - badge: optional custom right-aligned badge node. If omitted, falls back to
 *    the legacy "Completo" pill driven by `hasData`.
 *  - hasData: legacy boolean; renders the "Completo" pill when true and no badge given.
 *  - children: section body.
 */
const SectionShell = ({ id, title, icon, hasData, badge, children }) => (
  <section id={id} className="scroll-mt-6">
    <div className="rounded-xl border border-zinc-200 bg-white shadow-sm">
      <div className="flex items-center gap-3 px-4 pt-4">
        {icon && (
          <div
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg"
            style={{ backgroundColor: ACCENT + "1a", color: ACCENT }}
          >
            {React.cloneElement(icon, { className: "h-4 w-4" })}
          </div>
        )}
        <div className="flex-1 font-semibold text-zinc-900">{title}</div>
        {badge
          ? badge
          : hasData && (
              <span
                className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium"
                style={{ backgroundColor: ACCENT + "1a", color: ACCENT }}
              >
                <CheckCircleIcon className="h-3.5 w-3.5" />
                Completo
              </span>
            )}
      </div>
      <div className="px-5 pb-5 pt-3">{children}</div>
    </div>
  </section>
);

export default SectionShell;
